// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"JQ-z","sponsoredTooltipWrapper":"KQ-z","sponsoredTooltip":"LQ-z","newCard":"MQ-z"};